<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form>
          <div class="my-5"></div>
          <div class="row">
            <div class="col-4 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">Nombre</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="exampleInputEmail1">Apellido</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">DNI</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">CUIL</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="exampleInputEmail1">Fecha de nacimiento</label>
                <div class="row">
                  <div class="col-md-12">
                    <date-picker v-model="date" :config="options"></date-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3 offset-1">

            <div class="form-group">
                <div class="fg-line">
                    <label>Nacionalidad:</label>
                    <div class="select">
                        <select v-model="item.nationalitySelected" id="countryCode" name="countrySelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="citizenship of countries" :key="citizenship.code_iso_alfa3" :value="citizenship">{{ citizenship.citizenship }}</option>
                        </select>
                    </div>
                </div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>

              <!-- <div class="form-group">
                <label for="exampleInputEmail1">Nacionalidad</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div> -->
            </div>
            <div class="col-3 offset-1">
            <div class="form-group">
                <div class="fg-line">
                    <label>País de Nacimiento:</label>
                    <div class="select">
                        <select v-model="item.countrySelected" @change="getProvinces(item.countrySelected)" id="countryCode" name="countrySelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="country of countries" :key="country.code_iso_alfa3" :value="country">{{ country.common_name}}</option>
                        </select>
                    </div>
                </div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-3">
            <div class="form-group">
                <div class="fg-line">
                    <label>Provincia de Nacimiento:</label>
                    <div class="select">
                        <select v-model="item.ProvinceSelected" id="ProvinceCode" name="ProvinceSelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="province of provinces" :key="province.code_iso" :value="province">{{ province.name}}</option>
                        </select>
                    </div>
                </div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">Localidad de Nacimiento</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3 offset-1">
            <div class="form-group">
                <div class="fg-line">
                    <label>Grupo Sanguíneo:</label>
                    <div class="select">
                        <select v-model="item.bloodGroupSelected" id="bloodGrupCode" name="bloodGroupSelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="bloodG of bloodGroups" :key="bloodG.code" :value="bloodG">{{ bloodG.name}}</option>
                        </select>
                    </div>
                </div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>

            <div class="col-3">
            <div class="form-group">
                <div class="fg-line">
                    <label>Factor Sanguíneo:</label>
                    <div class="select">
                        <select v-model="item.bloodFactorSelected" id="bloodFactorCode" name="bloodFactorSelected" class="form-control"><!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="bloodF of bloodFactors" :key="bloodF.code" :value="bloodF">{{ bloodF.name}}</option>
                        </select>
                    </div>
                </div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTPFront } from '../../share';
export default {
  props: ["clickedNext", "currentStep"],
  /* mixins: [validationMixin], */
  data() {
    return {
      item: {
        nationalitySelected:'',
        countrySelected: '',
        ProvinceSelected: '',
        bloodGroupSelected: '',
        bloodFactorSelected:''
      },
      citizenships: null,
      countries:null,
      provinces:null,
      bloodGroups:null,
      bloodFactors:null,
      date: new Date(),
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        widgetPositioning: {
          vertical: "bottom",
        },
      },
    };
  },
  created() {
    this.$emit("can-continue", { value: true });
    this.getCountries();
    this.getBloodGroups();
    this.getBloodFactors();
  },

  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.form.$touch();
      }
    },
  },
  /* mounted() {
    if (!this.$v.$invalid) {
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  }, */
  methods: {
    getCountries() {
      HTTPFront.get('/getCountries')
      .then(res => {
        this.countries = res.data;
      })
    },
    getProvinces(countrySelected){
      HTTPFront.get('/getProvincesByCountry/'+countrySelected.code_iso_alfa3)
      .then(res => {
        this.provinces = res.data;
      })
    },
    getBloodGroups() {
      HTTPFront.get('/getBloodGroups')
      .then(res => {
        this.bloodGroups = res.data;
      })
    },
    getBloodFactors() {
      HTTPFront.get('/getBloodFactors')
      .then(res => {
        this.bloodFactors = res.data;
      })
    }
  }
};
</script>